// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1t2pU","left":"InfoRow_left__ePRCH"};